'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _FlipMove = require('./FlipMove');

var _FlipMove2 = _interopRequireDefault(_FlipMove);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _FlipMove2.default;
/**
 * React Flip Move
 * (c) 2016-present Joshua Comeau
 */

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ../~/react-flip-move/lib/index.js
// module id = 1074
// module chunks = 0